import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root',
})
export class MyInformationService {
  constructor(private readonly httpService: AmplifyHttpClient) {}

  getRootFolders(userId) {
    const url = `api/office-vault/sub-folder/${userId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getSubFolders(userId, folderId) {
    const url = `api/office-vault/sub-folder/${userId}/${folderId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getFolderDetails(userId, folderId) {
    const url = `api/office-vault/folder/${userId}/${folderId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getFolderHierarchy(folderId) {
    const url = `api/office-vault/folder-hierachy/${folderId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }
  createOfficeVaultFolder(request) {
    const url = `api/office-vault/folder`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  renameOfficeVaultFolder(request) {
    const url = `api/office-vault/folder`;
    return this.httpService.patch(url, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getRootForms() {
    const url = `api/office-vault/forms`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getFolderForms(folderId) {
    const url = `api/office-vault/forms/${folderId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  // SHARE FOLDER
  createShareFolder(request) {
    const url = `api/office-vault/share-folder`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getShareFolder(folderId) {
    const url = `api/office-vault/share-folder/${folderId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  deleteShareFolder(folderId, userId) {
    const url = `api/office-vault/share-folder/${folderId}/${userId}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  // SHARE FILE
  createShareFile(request) {
    const url = `api/office-vault/share-form`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getShareFile(folderId) {
    const url = `api/office-vault/share-form/${folderId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  deleteShareFile(folderId, userId) {
    const url = `api/office-vault/share-form/${folderId}/${userId}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  deleteMyInformationFolderForever(folderId) {
    const url = `api/office-vault/folder/${folderId}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveMyInformationFile(request) {
    const url = 'api/office-vault/move-office-vault-forms';
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getMyInformationFolderDownloadUrl(folderId) {
    const url = `api/office-vault/office-vault-folder-download-url/${folderId}`;
    return this.httpService.post(url, {}).pipe((res: any) => {
      return res;
    });
  }
}
